import Search from "../../utils/Search";

export const setBadgeType = (item) => {
  const type = item.live_enabled === '1' ? 'live' : 'vod';
  const groupId = item.id;
  return Search.setBadgeType(type, groupId)
}



// WEBPACK FOOTER //
// ./src/components/Ribbon/utils.js